import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {PhoneModalComponent} from '../applications/phone-modal/phone-modal.component';

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  constructor(private modalService: NgbModal) {}

  openPhoneModal() {
      const modalRef = this.modalService.open(PhoneModalComponent, {
          backdrop: 'static', // Empêche la fermeture en cliquant à l'extérieur
          keyboard: false     // Empêche la fermeture avec la touche ESC
      });
    // const modalRef = this.modalService.open(PhoneModalComponent);
    // modalRef.result.then(
    //     (result) => {
    //       console.log('Modal fermé avec :', result);
    //     },
    //     (reason) => {
    //       console.log('Modal dismiss avec :', reason);
    //     }
    // );
  }
}